import stockApi from '../../services/StockApi'

export const removeBatch = async (idBatch, userBadge) => {
    const axiosConfig = {
        headers: {
            'user-barcode': userBadge
        },
        data: {
            id_batch : idBatch
        }
    }

    const { data } = await stockApi.delete('/receivement/batch', axiosConfig);

    return data
}

export const removePendingBatch = async (idPendingBatch, userBadge) => {
    const axiosConfig = {
        headers: {
            'user-barcode': userBadge
        },
        data: {
            id_pending_batch : idPendingBatch
        }
    }

    const { data } = await stockApi.delete('/receivement/batch', axiosConfig);

    return data
}